export default __webpack_public_path__ + "static/media/tiktok_icon.0cd27dcf.svg";